module.exports = __webpack_public_path__ + "media/explainer.634bdc4f.mp4";